import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InnerSection, Section, SectionAttributes } from '../../types/section';
import { SectionComponent } from '../../components/section/section.component';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { iconFacebook, iconInstagram, iconLinkedin, iconTwitter, iconXing, iconYoutube } from '@knorr-bremse-portals/icons';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type SocialMediaLinkListSection = Section<
  {
    items: SocialMediaLinkSection[];
    headline?: string;
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'items',
  ],
  'items'
>;
const iconMap = {
  'facebook': iconFacebook,
  'instagram': iconInstagram,
  'linkedin': iconLinkedin,
  'twitter': iconTwitter,
  'xing': iconXing,
  'youtube': iconYoutube,
} as const;

interface SocialMediaLinkAttributes extends SectionAttributes {
  url: string;
  icon: keyof typeof iconMap;
}
type SocialMediaLinkSection = InnerSection<SocialMediaLinkAttributes, [], 'social-media-link'>;



@Component({
  selector: 'app-social-media-linklist',
  imports: [
    RouterOrExternalLinkDirective,
    IconComponent,
    FsButtonComponent,
  ],
  templateUrl: './social-media-linklist.component.html',
  styleUrl: './social-media-linklist.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialMediaLinklistComponent extends SectionComponent<SocialMediaLinkListSection>{
  protected iconMap = iconMap;
}
